import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__image-upload-container, .js__image-upload-container-parent > *';
export default class FileSizeValidation {
    static init() {
        const $element = $(ELEMENT_SELECTOR);
        if (!$element.length) {
            return;
        }
        $element.find('[type="file"]').on('change', e => {
            const $currentInput = $(e.currentTarget);
            const $inputWrapper = $currentInput.closest(ELEMENT_SELECTOR);
            const maxSize = $inputWrapper.data('max-size') || 1024 * 1024;
            const $errorText = $inputWrapper.find('.js__file-size-error');
            $errorText.remove();
            if (!$('.js__file-size-error').length) {
                this.enableSubmit($currentInput);
            }
            if (!window.FileReader) {
                console.log(`The file API isn't supported on this browser yet.`);
                return;
            }
            if (!$currentInput[0].files) {
                console.error(`This browser doesn't seem to support the "files" property of file inputs.`);
            }
            else {
                const file = $currentInput[0].files[0];
                if (file.size > maxSize * 1024 * 1024) {
                    this.addError($currentInput, 'File is too big');
                    this.disableSubmit($currentInput);
                }
            }
        });
    }
    static addError($input, text) {
        const $erorrText = $(`<div class="ui red pointing label js__file-size-error">${text}</div>`);
        $input.closest(ELEMENT_SELECTOR).append($erorrText);
    }
    static disableSubmit($input) {
        const $submitButton = $input.closest('form').find('[type="submit"]');
        $submitButton.prop('disabled', true);
    }
    static enableSubmit($input) {
        const $submitButton = $input.closest('form').find('[type="submit"]');
        $submitButton.prop('disabled', false);
    }
}
